module.exports = __webpack_public_path__ + "img/2914099-35-5.2d8c4001.png";